import { HttpClient, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AddressService {
  constructor(private http: HttpClient) {}
  getById(id: number) {
    return this.http
      .post<any>(`${environment.apiUrl}/catalogue/address/get_by_address_id`, {
        id: id
      })
      .pipe(
        catchError((res: HttpErrorResponse) => {
          if (res.status === HttpStatusCode.InternalServerError) {
            return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
          }
          if (res.status === HttpStatusCode.BadRequest) {
            return throwError(() => res.error)
          }
          if (res.status === HttpStatusCode.Unauthorized) {
            return throwError(() => 'El acceso a esta solicitud no estas permitido')
          }
          return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
        }),
        map((response: any) => {
          if (response.hasOwnProperty('payload')) {
            return response.payload.data
          }
          return response
        })
      )
  }

  getByIdUser(identification_user_info: string) {
    return this.http
      .post<any>(`${environment.apiUrl}/catalogue/address/address_by_id`, {
        identification_user: identification_user_info
      })
      .pipe(
        catchError((res: HttpErrorResponse) => {
          if (res.status === HttpStatusCode.InternalServerError) {
            return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
          }
          if (res.status === HttpStatusCode.BadRequest) {
            return throwError(() => res.error)
          }
          if (res.status === HttpStatusCode.Unauthorized) {
            return throwError(() => 'El acceso a esta solicitud no estas permitido')
          }
          return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
        }),
        map((response: any) => {
          if (response.hasOwnProperty('payload')) {
            return response.payload.data
          }
          return response
        })
      )
  }

  create(address: any) {
    return this.http.post<any>(`${environment.apiUrl}/catalogue/address`, address).pipe(
      catchError((res: HttpErrorResponse) => {
        if (res.status === HttpStatusCode.InternalServerError) {
          return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
        }
        if (res.status === HttpStatusCode.BadRequest) {
          return throwError(() => res.error)
        }
        if (res.status === HttpStatusCode.Unauthorized) {
          return throwError(() => 'El acceso a esta solicitud no estas permitido')
        }
        return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
      }),
      map((response: any) => {
        if (response.hasOwnProperty('payload')) {
          return response.payload.data
        }
        return response
      })
    )
  }

  update(address: any) {
    return this.http.put<any>(`${environment.apiUrl}/catalogue/address`, address).pipe(
      catchError((res: HttpErrorResponse) => {
        if (res.status === HttpStatusCode.InternalServerError) {
          return throwError(() => 'Algo esta fallando en el servidor, por favor contacte a soporte')
        }
        if (res.status === HttpStatusCode.BadRequest) {
          return throwError(() => res.error)
        }
        if (res.status === HttpStatusCode.Unauthorized) {
          return throwError(() => 'El acceso a esta solicitud no estas permitido')
        }
        return throwError(() => 'Ups algo salio mal, por favor contacte a soporte')
      }),
      map((response: any) => {
        if (response.hasOwnProperty('payload')) {
          return response.payload.data
        }

        console.log('estos son los response: ', response)

        return response
      })
    )
  }
}
